__turbopack_context__.v({
  "anchorScope": "PopoverContent-module__tNjPBG__anchorScope",
  "anchorTrigger": "PopoverContent-module__tNjPBG__anchorTrigger",
  "anchoredPopover": "PopoverContent-module__tNjPBG__anchoredPopover",
  "popover": "PopoverContent-module__tNjPBG__popover" + " " + "PopoverContent-module__tNjPBG__anchoredPopover",
  "popoverDelayedFadeIn": "PopoverContent-module__tNjPBG__popoverDelayedFadeIn",
  "popoverInner": "PopoverContent-module__tNjPBG__popoverInner" + " " + "cds-t-body",
});
